import gql from 'graphql-tag';

import userGroupFragment from './user-group-fragment';

export default gql`
  mutation updateByIdUserGroupMutation(
    $_id: MongoID!
    $record: UpdateByIdUserGroupInput!
  ) {
    updateByIdUserGroupMutation(_id: $_id, record: $record) {
      record {
        ...UserGroupFragment
      }
    }
  }
  ${userGroupFragment}
`;
